export const getFormatedChannelAndTvScheduleIds = currentUrl => {
  const [channelsAndtvSchedulesIds] = currentUrl.split('/').reverse();
  return channelsAndtvSchedulesIds.replace('?', '/').replace('=', '/');
};
